<template>
  <v-window-item value="approval-history">
    <v-card-text class="pa-4 pa-sm-6">
      <v-alert v-if="approvalHistoryData.length === 0" type="info" variant="tonal">
        No approval action has been recorded yet.
      </v-alert>

      <v-timeline
        v-else
        align="start"
        density="comfortable"
        side="end"
        line-thickness="2"
      >
        <v-timeline-item
          v-for="item in approvalHistoryData"
          :key="item.id"
          :dot-color="statusColor(item.status)"
          :icon="statusIcon(item.status)"
          icon-color="white"
          size="small"
        >
          <template #opposite>
            <v-chip variant="tonal" :color="statusColor(item.status)" class="text-caption text-medium-emphasis text-no-wrap">
              {{ formatDate(item.approved_at) }}
            </v-chip>
          </template>

          <v-card variant="tonal" :color="statusColor(item.status)">
            <v-card-item class="pb-2">
              <template #prepend>
                <v-icon :color="statusColor(item.status)" class="mr-2">
                  {{ statusIcon(item.status) }}
                </v-icon>
              </template>
              <v-card-title class="text-body-1 font-weight-bold px-0">
                {{ approvalTitle(item) }}
              </v-card-title>
              <v-card-subtitle class="px-0">
                {{ actorName(item) }} · {{ stepName(item) }}
              </v-card-subtitle>
              <template #append>
                <v-chip :color="statusColor(item.status)" size="small" variant="flat">
                  {{ statusLabel(item.status) }}
                </v-chip>
              </template>
            </v-card-item>

            <v-card-text v-if="item.comments" class="pt-0 text-body-2">
              <span class="font-weight-medium">Comment:</span> {{ item.comments }}
            </v-card-text>
          </v-card>
        </v-timeline-item>
      </v-timeline>
    </v-card-text>
  </v-window-item>
</template>

<script>
export default {
  props: {
    approvalHistoryData: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    formatDate(value) {
      if (!value) return "Pending";

      const date = new Date(value);
      return Number.isNaN(date.getTime()) ? "-" : date.toLocaleString();
    },
    normalizedStatus(status) {
      return status?.toLowerCase() || "pending";
    },
    statusLabel(status) {
      return {
        approved: "Approved",
        cancelled: "Rejected",
        rejected: "Rejected",
        forwarded: "Forwarded",
        pending: "Pending",
      }[this.normalizedStatus(status)] || "Pending";
    },
    actorName(item) {
      return item.approved_by?.full_name
        || item.employee?.name
        || "Waiting for approver";
    },
    stepName(item) {
      return item.approval_step_name?.name || "Approver";
    },
    approvalTitle(item) {
      return {
        approved: "Approval completed",
        cancelled: "Approval rejected",
        rejected: "Approval rejected",
        forwarded: "Approval forwarded",
        pending: "Approval pending",
      }[this.normalizedStatus(item.status)] || "Approval pending";
    },
    statusColor(status) {
      return {
        approved: "success",
        pending: "warning",
        forwarded: "info",
        cancelled: "error",
        rejected: "error",
      }[this.normalizedStatus(status)] || "grey";
    },
    statusIcon(status) {
      return {
        approved: "mdi-check-circle-outline",
        pending: "mdi-clock-outline",
        forwarded: "mdi-share-outline",
        cancelled: "mdi-close-circle-outline",
        rejected: "mdi-close-circle-outline",
      }[this.normalizedStatus(status)] || "mdi-help-circle-outline";
    },
  },
};
</script>
